import { ObjectListResponseType } from '../ObjectListResponseTypes'

export interface DealResponse {
  dealId: number
  date: Date
  company: string
  companyNumber: string
  address: string
  solution: number[]
  solutionOther: string
  description: string
  status: string
  name: string
  ticketId: number
  claimedUntil: Date
  accountManager: string
}

export interface DealCreatedResponse {
  id: number
  date: Date
  company: string
  companyNumber: string
  description: string
  address: string
  solution: number[]
  solutionOther: string
  phonenumber: string
  mail: string
  firstname: string
  lastname: string
  status: string
  name: string
  ticketId: number
  claimedUntil: Date
  files: Array<File>
}

export interface DealCreateResponse {
  id: string
}

interface DealListResponse extends ObjectListResponseType {
  deals: DealResponse[]
}

const isDealListResponse = (response: any): response is DealListResponse => {
  if (!Array.isArray(response)) {
    return false
  }
  return response.every((item) => {
    return (
      typeof item === 'object' &&
      item !== null &&
      typeof item.dealId === 'number' &&
      typeof item.company === 'string' &&
      'status' in item &&
      'ticketId' in item
    )
  })
}

const isDealCreateResponse = (response: any): response is DealCreateResponse => {
  if (response === undefined) {
    return false
  }
  return response
}

export { isDealListResponse, isDealCreateResponse }
